import React from 'react'
import Hero from '../components/Hero';
import { useIntl } from 'react-intl';
import TelecomLinkBoxRow from '../components/TelecomLinkBoxRow';

export type TelecommunicationsPageProps = {};

const TelecommunicationsPage: React.FC<TelecommunicationsPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-20">
        <div className="w-full">
          <img className="w-full" src="/img/city-telecom.png" alt="NOM-016-SCFI-1993 Office Devices" />
        </div>
      </div>
    </div>
  );
}

export default TelecommunicationsPage;